import React from 'react';
import { footerData } from '../data/mock';
import { Linkedin, Mail } from 'lucide-react';

const LINKEDIN_URL = 'https://www.linkedin.com/in/santanudsharma/';
const EMAIL = 'shantanu.neuromind.leadership@gmail.com';

export const Footer = () => {
  return (
    <footer className="bg-[#fffef2] border-t border-[#e8e7da] relative">
      {/* Decorative top line */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-px bg-gradient-to-r from-transparent via-[#c9a87c] to-transparent" />
      
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
        <div className="grid md:grid-cols-3 gap-8 items-center">
          {/* Left - Branding */}
          <div>
            <p className="font-serif text-xl text-[#333333] mb-2">
              {footerData.name}
            </p>
            <p className="text-sm text-[#666666]">
              {footerData.tagline}
            </p>
          </div>

          {/* Center - Social Links */}
          <div className="flex items-center justify-center gap-6">
            <a
              href={LINKEDIN_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center gap-2 text-[#666666] hover:text-[#5a7fa8] transition-colors duration-300"
            >
              <div className="w-10 h-10 rounded-full border border-[#bcbbb4] flex items-center justify-center group-hover:border-[#5a7fa8] group-hover:bg-[#5a7fa8]/5 transition-all duration-300">
                <Linkedin size={18} />
              </div>
              <span className="text-sm hidden sm:inline">LinkedIn</span>
            </a>
            
            <a
              href={`mailto:${EMAIL}`}
              className="group flex items-center gap-2 text-[#666666] hover:text-[#c9a87c] transition-colors duration-300"
            >
              <div className="w-10 h-10 rounded-full border border-[#bcbbb4] flex items-center justify-center group-hover:border-[#c9a87c] group-hover:bg-[#c9a87c]/5 transition-all duration-300">
                <Mail size={18} />
              </div>
              <span className="text-sm hidden sm:inline">Email</span>
            </a>
          </div>

          {/* Right - Note & Copyright */}
          <div className="md:text-right">
            <p className="text-sm text-[#5a7fa8] italic mb-3">
              {footerData.note}
            </p>
            <p className="text-xs text-[#bcbbb4]">
              {footerData.copyright}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
